/**
 * Why a read failed, in plain words, for the screens that read one list or one record.
 *
 * The Brand Kit says «Never show the raw text of a server error», and the guidelines forbid a raw
 * status code. So a screen keeps the HTTP status only to choose the sentence, and shows the
 * sentence alone: refused (401, 403), the service not answering (5xx, or no answer at all), or
 * anything else.
 */
export type ReadErrorKey =
  'errors:read.forbidden' | 'errors:read.unavailable' | 'errors:read.failed';

export function readErrorKey(httpStatus: number | undefined): ReadErrorKey {
  if (httpStatus === 401 || httpStatus === 403) {
    return 'errors:read.forbidden';
  }
  if (httpStatus === undefined || httpStatus >= 500) {
    return 'errors:read.unavailable';
  }
  return 'errors:read.failed';
}
